const headerSearch = (() => {

    const initBlock = el => {
        const input = el.querySelector("input");
        const results = el.querySelector('[data-results]');
        input.addEventListener('keyup',
            debounce(() => {
                let value = input.value;
                if (value.length > 2) {
                    fetch(`/umbraco/surface/SearchSurface/Search?searchTerm=${value}`)
                        .then(response => response.text())
                        .then(data => {
                            results.innerHTML = data;
                        });
                }
            }, 500))
    };

    return { initBlock };
})();

ControlBinders.register(`[data-search]`, el => headerSearch.initBlock(el));